import gql from "graphql-tag";

const notificationObj = `
id
isViewed
  isClicked
  title
  body
  service
  link itemId
  author {
    id username fullname
  }
  createdAt
  updatedAt

`;

export default {
  notifications: gql`
    query ($status: String, $service: String, $isViewed: Boolean $limit: Int
      $page: Int 	$isClicked: Boolean){
      notifications(filter: {
        status: $status,
        isViewed: $isViewed,
        service: $service
        isClicked: $isClicked
      }
        paging: {
          limit: $limit
          page: $page
        }
      ){ ${notificationObj}}
    }
  `,
  updateNotification: gql`
    mutation(
      $id: ID!
      $isViewed: Boolean
      $isClicked: Boolean
    ) {
      updateNotification(
        id: $id,
        data: {
          isViewed: $isViewed
          isClicked : $isClicked
        }
      ) {
              ${notificationObj}
      }
    }
  `,
  updateNotifications: gql`
    mutation(
      $ids: [ID!]!
      $isViewed: Boolean
    ) {
      updateNotifications(
        ids: $ids,
        data: {
          isViewed: $isViewed
        }
      ) {${notificationObj}}
    }
  `,
  subNotification: gql`
    subscription {
      notification {
        mutation
        node {${notificationObj}}
      }
    }
  `,
};
